<template>
  <div>
    <!-- PLACA -->
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <v-text-field
          v-model="placa"
          label="Placa do Veículo *"
          placeholder="ABC1D23"
          outlined
          maxlength="7"
          :loading="loading"
          :error-messages="erro"
          :rules="[rules.required]"
          @keydown="bloquearCaracterInvalido"
          @input="onInput"
        />
      </v-col>
    </v-row>

    <!-- ALERTA LICENCIAMENTO -->
    <v-alert
      v-if="alertaLicenciamento"
      type="warning"
      outlined
      dense
      class="mt-2"
    >
      <strong>Veículo não licenciado junto ao DETRAN-CE.</strong><br>
      Ano do último licenciamento:
      <strong>{{ alertaLicenciamento.ano }}</strong>.<br>
      Inclusão não permitida.
    </v-alert>

    <!-- LOADING -->
    <v-row
      v-if="loading && !erro"
      class="mt-2"
    >
      <v-col
        cols="12"
        class="text-center"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        />
        <div class="mt-2 text--secondary">
          Consultando DETRAN...
        </div>
      </v-col>
    </v-row>

    <!-- DADOS DO VEÍCULO -->
    <v-row v-if="veiculo.carregado && !loading">
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          label="Marca / Modelo"
          outlined
          dense
          readonly
          :value="veiculo.marcaModelo"
        />
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
        <v-text-field
          label="Ano Modelo"
          outlined
          dense
          readonly
          :value="veiculo.anoModelo"
        />
      </v-col>

      <v-col
        cols="12"
        md="3"
      >
        <v-text-field
          label="Ano Fabricação"
          outlined
          dense
          readonly
          :value="veiculo.anoFabricacao"
        />
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <v-text-field
          label="Cor"
          outlined
          dense
          readonly
          :value="veiculo.cor"
        />
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <v-text-field
          label="Renavam"
          outlined
          dense
          readonly
          :value="veiculo.renavam"
        />
      </v-col>

      <v-col
        cols="12"
        md="4"
      >
        <v-text-field
          label="Chassi"
          outlined
          dense
          readonly
          :value="veiculo.chassi"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          label="Proprietário"
          outlined
          dense
          readonly
          :value="veiculo.nomeProprietario"
        />
      </v-col>
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          label="CPF/CNPJ Proprietário"
          outlined
          dense
          readonly
          :value="cpfCnpjProprietarioFormatado"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import cpvService from '@/services/cpv/cpv.service';
import { formatCpfCnpjDisplay } from '@/helpers/cpf-cnpj-display';

export default {
  name: 'ModalBuscaPlacaDetran',
  emits: ['update'],

  data() {
    return {
      placa: '',
      loading: false,
      erro: '',
      alertaLicenciamento: null,

      veiculo: {
        carregado: false,
        marcaModelo: '',
        cor: '',
        anoFabricacao: '',
        anoModelo: '',
        renavam: '',
        chassi: '',
      },
      rules: {
        required: v => !!v || 'Campo obrigatório',
      }
    };
  },

  computed: {
    cpfCnpjProprietarioFormatado() {
      return formatCpfCnpjDisplay(this.veiculo.cpfCnpjProprietario);
    },
  },

  methods: {
    bloquearCaracterInvalido(e) {
      const permitidos = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
      if (permitidos.includes(e.key)) return;
      if (!/^[a-zA-Z0-9]$/.test(e.key)) e.preventDefault();
      if (this.placa.length >= 7) e.preventDefault();
    },

    onInput() {
      this.placa = (this.placa || '')
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '')
        .slice(0, 7);

      this.erro = '';
      this.alertaLicenciamento = null;
      this.resetVeiculo();

      if (this.placa.length === 7) {
        this.buscar();
      }
    },

    buscar() {
      this.loading = true;

      cpvService.checkPlateOnDetran(this.placa)
        .subscribe({
          next: res => {
            const r = res.result;
            if (!r) return this.fail('Placa não encontrada');

            if (r.debitoLicenciamento) {
              const ano = r.anoLicenciamentoPago;

              this.alertaLicenciamento = { ano };

              this.veiculo = {
                carregado: false,
                marcaModelo: '',
                cor: '',
                anoFabricacao: '',
                anoModelo: '',
                renavam: '',
                chassi: '',
                cpfCnpjProprietario: '',
                nomeProprietario: ''
              };

              this.$emit('update', {
                placa: this.placa,
                ...this.veiculo,
                debitoLicenciamento: true,
                anoLicenciamentoPago: ano,
                bloqueadoLicenciamento: true,
              });

              return;
            }

            this.veiculo = {
              carregado: true,
              marcaModelo: r.marcaModelo,
              cor: r.cor,
              anoFabricacao: r.anoFabricacao,
              anoModelo: r.anoModelo,
              renavam: r.renavam,
              chassi: r.chassi,
              cpfCnpjProprietario: r.cpfCnpjProprietario,
              nomeProprietario: r.nomeProprietario
            };

            this.emitir();
          },
          error: () => this.fail('Placa não encontrada'),
          complete: () => (this.loading = false),
        });
    },

    fail(msg) {
      this.erro = msg;
      this.alertaLicenciamento = null;
      this.resetVeiculo();
      this.loading = false;
    },

    resetVeiculo() {
      this.veiculo = {
        carregado: false,
        marcaModelo: '',
        cor: '',
        anoFabricacao: '',
        anoModelo: '',
        renavam: '',
        chassi: '',
      };

      this.$emit('update', {
        placa: this.placa,
        ...this.veiculo,
        debitoLicenciamento: false,
        anoLicenciamentoPago: null,
        bloqueadoLicenciamento: false,
      });
    },

    emitir() {
      this.$emit('update', {
        placa: this.placa,
        ...this.veiculo,
        debitoLicenciamento: false,
        anoLicenciamentoPago: null,
        bloqueadoLicenciamento: false,
      });
    },
  },
};
</script>
